import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';

import useDebounce from '../../../utilities/hooks/useDebounce/useDebounce';
import FloatingSearchBox from '../../../components/mazraeKit/floatingSearchBox';
import useGeAddressByTitleSearch from '../../../services/hookService/getLocationByTitleSearch/useGeAddressByTitleSearch';
import DotsLoading from '../../../components/dotsLoading';
import {addAddress} from '../../../store/redux/myStoreSelectedLocation';

const RegisteringSearchingLocation = () => {
  const {state} = useLocation();
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState<string>(state?.searchBarAddress);
  const debouncedValue = useDebounce(inputValue, 2000);
  const navigate = useNavigate();

  useEffect(() => {
    setInputValue(state?.searchBarAddress);
  }, [state.searchBarAddress]);

  const {address, isLoading} = useGeAddressByTitleSearch(debouncedValue);

  const handleClickAfterSelect = (item: ILocationByTitleSearch) => {
    dispatch(
      addAddress({
        id: item.id,
        name: `${item.name}`,
        location: item.location,
        state_id: item.state_id,
      }),
    );
    navigate('/my-store-add-location-by-map', {
      state: {
        type: state?.type,
        store_guid: state?.store_guid,
        lab_guid: state?.lab_guid,
      },
    });
  };

  return (
    <div className="w-full h-full px-3">
      <div className="flex justify-between h-14 items-center  border-b border-gray-200">
        <span>آدرس </span>
        <i
          className="icon-nameClose-remove text-xl font-Bold"
          onClick={() => navigate(-1)}
        />
      </div>
      <FloatingSearchBox
        label="جستجوی آدرس"
        type="text"
        value={inputValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setInputValue(e.target.value)
        }
        {...{inputValue, setInputValue}}
        isAutofcus={true}
      />
      {isLoading ? (
        <div className=" flex justify-center items-center h-full">
          <DotsLoading />
        </div>
      ) : (
        <>
          {address &&
            [...address?.city].map(item => (
              <div
                className="border-b-2 p-3"
                onClick={() => handleClickAfterSelect(item)}
              >
                {<span>{item.name}</span>}
              </div>
            ))}
        </>
      )}
    </div>
  );
};

export default RegisteringSearchingLocation;
